import React from 'react';

export const launcherCard: React.CSSProperties = {
    opacity: '0.9',
    boxShadow: '5px 8px 24px 5px rgba(208, 216, 243, 0.6)'
}

export const smallLauncherCard: React.CSSProperties = {
    ...launcherCard,
    width: '170px',
    margin: '2px'
}